import { useCallback } from "react";

export const useAutoFocus = <T extends HTMLElement = HTMLInputElement>(
  enabled = true
) => {
  const elementRef = useCallback(
    (element: T | null) => {
      if (enabled && element) {
        element.focus();
      }
    },
    [enabled]
  );

  return elementRef;
};
